/* Test 12: Kundenstimme statt Zahlungs-Icons (snippets/nw-ab-kundenstimme.liquid, docs/TESTS.md).

   - Produktseite mit Kundenstimme (window.nwKsStimme, aus snippets/nw-kundenstimme.liquid): sucht den Platz der
     Zahlungs-Icons (.ss-payment-list; die App-Section ss-payment-icons setzt die Liste beim Laden hinter das
     Produktformular) und merkt sich "Platz gesehen". In Gruppe 'stimme' steht direkt dahinter die Karte mit der
     Bewertung, die Liste selbst blendet das Snippet per CSS aus.
   - Warenkorb-Attribut _ab_pdp_stimme = icons/stimme, sobald der Besucher den Platz gesehen hat: beim Laden, nach jedem
     Hinzufügen und spätestens beim Klick auf "Zur Kasse" (max. 1,5 s). Wer nie eine Seite mit Kundenstimme geöffnet hat,
     bekommt keine Markierung und zählt in keiner Gruppe. In der Vorschau vor dem Start wird nichts markiert. */
(function () {
  var s = window.nwKs;
  if (!s) return;
  var KEY = '_ab_pdp_stimme';
  var k = window.nwKsStimme;

  function speichern() {
    if (s.vorschau) return;
    try { localStorage.setItem('nw_ab_ks', JSON.stringify(s)); } catch (e) {}
  }

  /* ---------- Karte ---------- */
  function bauen() {
    var box = document.createElement('div');
    box.className = 'nw-ks';
    box.innerHTML = '<span class="nw-ks__zitat" aria-hidden="true">“</span><div class="nw-ks__kopf">' +
      '<span class="nw-ks__sterne" role="img">★★★★★</span><span class="nw-ks__name"></span><span class="nw-ks__echt">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span></span></span>' +
      '</div><p class="nw-ks__text"></p>';
    box.querySelector('.nw-ks__sterne').setAttribute('aria-label', k.sterne);
    box.querySelector('.nw-ks__name').textContent = k.name;
    box.querySelector('.nw-ks__echt span').textContent = k.echt;
    box.querySelector('.nw-ks__text').textContent = k.auf + k.text + k.zu;
    return box;
  }

  var karte = null;
  function setzen() {
    if (!k) return;
    var info = document.querySelector('.product__info-container');
    var pay = info && info.querySelector('.ss-payment-list');
    if (!pay) return;
    if (!s.s && !s.vorschau) { s.s = 1; speichern(); ensure(); }
    if (s.g !== 'stimme') return;
    if (!karte) karte = bauen();
    if (pay.nextElementSibling !== karte) pay.insertAdjacentElement('afterend', karte);
  }
  // Die App setzt die Liste bei DOMContentLoaded ein – danach suchen, bei "load" und nach Variantenwechsel noch einmal.
  // Wer den Platz schon früher gesehen hat, wird beim Laden gleich markiert.
  function start() { setTimeout(function () { var schon = s.s; setzen(); if (schon) ensure(); }, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', setzen);
  document.addEventListener('change', function () { setTimeout(setzen, 400); });

  /* ---------- Markierung im Warenkorb ---------- */
  var confirmed = false, pending = null;
  function ensure() {
    if (!s.s || s.vorschau) return Promise.resolve();
    if (pending) return pending.then(ensure);
    // Schreiben andere Skripte (nw-upsell.js, nw-ab-tag) gleichzeitig Attribute, kann Shopify unser Attribut wieder
    // verlieren: deshalb nach dem Schreiben nachlesen und höchstens dreimal neu schreiben.
    function lesen() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    function drin(cart) { return (cart.attributes || {})[KEY] === s.g; }
    function versuch(n) {
      return lesen().then(function (cart) {
        if (!cart.item_count) return;
        if (drin(cart)) { confirmed = true; return; }
        if (!n) return;
        var a = {}; a[KEY] = s.g;
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a })
        }).then(function () { return new Promise(function (r) { setTimeout(r, 1000); }); })
          .then(function () { return versuch(n - 1); });
      });
    }
    pending = versuch(3)
      .catch(function () {})
      .then(function () { pending = null; });
    return pending;
  }

  // Nach dem Hinzufügen (Kaufbutton, Kaching, Warenkorb) – ohne fetch anzufassen, über die Ladezeiten-Einträge des Browsers.
  // Kurz warten, damit nw-upsell.js seine Attribute zuerst schreibt.
  try {
    new PerformanceObserver(function (liste) {
      if (liste.getEntries().some(function (e) { return /\/cart\/add/.test(e.name); })) {
        confirmed = false;
        setTimeout(ensure, 800);
      }
    }).observe({ type: 'resource' });
  } catch (e) {}

  // Fehlt die Markierung beim Klick auf "Zur Kasse" noch, wird sie zuerst gesetzt (max. 1,5 s)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], a[href^="/checkout"]');
    if (!btn || confirmed || !s.s || s.vorschau || btn.dataset.nwKsGo === '1') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    Promise.race([ensure(), new Promise(function (r) { setTimeout(r, 1500); })]).then(function () {
      btn.dataset.nwKsGo = '1';
      btn.click();
      setTimeout(function () { btn.dataset.nwKsGo = ''; }, 3000);
    });
  }, true);
})();
